import { useSpeechRecognition } from '../hooks/useSpeechRecognition';
import { haptic } from '../utils/haptic';

interface Props {
  onTranscribed: (text: string) => void;
  /** Request TTS summary of recent terminal output */
  onSummary?: () => void;
  /** Whether a summary is being generated */
  summarizing?: boolean;
  /** BCP-47 language tag (e.g. 'en-US') */
  speechLang?: string;
}

/**
 * Floating push-to-talk mic button + summary button for SSH terminal mode.
 * Uses device-native Web Speech API — transcribed text is typed into the terminal.
 */
export function SshPttButton({ onTranscribed, onSummary, summarizing, speechLang }: Props) {
  const { supported, listening, start, stop } = useSpeechRecognition();

  const handleMicToggle = (e: Event) => {
    e.preventDefault();
    if (!supported) return;
    if (listening) {
      stop();
    } else {
      haptic();
      start(
        (text) => { if (text) onTranscribed(text); },
        speechLang,
      );
    }
  };

  return (
    <div class="ssh-fab-group">
      {onSummary && (
        <button
          class={`ssh-summary-fab${summarizing ? ' busy' : ''}`}
          onClick={onSummary}
          disabled={summarizing}
          title={summarizing ? 'Summarizing...' : 'Read last output'}
        >
          {summarizing ? '⏳' : '📢'}
        </button>
      )}
      <button
        class={`ssh-ptt-fab${listening ? ' recording' : ''}`}
        onClick={handleMicToggle}
        title={listening ? 'Tap to stop' : 'Tap to dictate'}
      >
        {listening ? '\u23F9' : '\uD83C\uDF99'}
      </button>
    </div>
  );
}
